var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "content" }, [
            _c("img", {
              attrs: {
                src: require("../assets/img/goods/paysuccess.png"),
                alt: ""
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "suctip1" }, [_vm._v("付款成功")]),
            _vm._v(" "),
            _c("div", { staticClass: "suctip2" }, [_vm._v("感谢您的购买～")]),
            _vm._v(" "),
            _c("div", { staticClass: "returnbtn", on: { click: _vm.gohome } }, [
              _vm._v("返回主页")
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }